"use strict";

var segment;
var isFunction = function(value) {
  return typeof value === "function";
};

var integrations = require("./segment-integrations");
var googleClientIdIntegration = require("./segment-integrations/google-client-id");
var yolaCookies = require("./segment-integrations/yola-cookies");

var logInfo = function(data) {
  console.info("Segment.io tracking data");
  console.info("Title: " + data.title);
  console.info("Path: " + data.path);
};

var logEvent = function(event) {
  console.info("Segment.io fired event for: " + event);
};

var logUser = function(userId) {
  console.info("Segment.io detected user ID: " + userId);
};

var integrationRegistry = {};

segment = {
  isConfigured: false,
  isReady: false,
  callbackQueue: [],
  integrations: {
    GOOGLE_CLIENT_ID: "GOOGLE_CLIENT_ID",
    YOLA_COOKIES: "YOLA_COOKIES",
  },
  isInitialized: function() {
    return Boolean(window.analytics && window.analytics.initialized);
  },
  ready: function(callback) {
    this.callbackQueue.push(callback);
    setTimeout(function(){
      if (this.isReady) {
        this.execute();
      }
    }.bind(this), 50);
  },
  execute: function() {
    for (var i = 0; i < this.callbackQueue.length; i++) {
      var callback = this.callbackQueue[i];
      callback();
    }
    this.callbackQueue = [];
  },
  trackAnalyticsReady: function() {
    var intervalId;
    intervalId = setInterval(function() {
      if (this.isInitialized()) {
        this.isReady = true;
        this.execute();
        clearInterval(intervalId);
      }
    }.bind(this), 50);
  },
  init: function(key, baseUrl) {
    if (!key) {
      console.error('Segment key is missing!');
    }
    segment._baseUrl = baseUrl;
    // Segment.io initilalization code
    var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else {
      analytics.invoked = !0;
      analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "addSourceMiddleware", "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware"];
      analytics.factory = function (e) {
        return function () {
          var t = Array.prototype.slice.call(arguments);
          t.unshift(e);
          analytics.push(t);
          return analytics;
        };
      };
      for (var e = 0; e < analytics.methods.length; e++) {
        var k = analytics.methods[e];
        analytics[k] = analytics.factory(k);
      }
      analytics.load = function (key, e) {
        var t = document.createElement("script");
        t.type = "text/javascript";
        t.async = !0;
        t.src = baseUrl + "auditor/pb/events/script/?key=" + key;
        var n = document.getElementsByTagName("script")[0];
        n.parentNode.insertBefore(t, n);
        analytics._loadOptions = e;
      };
      analytics._writeKey = key;
      analytics._cdn = baseUrl + "auditor/pb/cdn";
      analytics.SNIPPET_VERSION = "4.15.2";
      analytics.load(key);
    }

    this.isConfigured = true;
    this.trackAnalyticsReady();

    this.unregisterIntegration();
    this.registerIntegration(this.integrations.GOOGLE_CLIENT_ID, googleClientIdIntegration);
    this.registerIntegration(this.integrations.YOLA_COOKIES, yolaCookies);

    return this;
  },
  registerIntegration: function(integrationName, callback) {
    if(integrationRegistry[integrationName]) {
      throw new Error('integration "' + integrationName + '" exists');
    }
    integrationRegistry[integrationName] = callback;
  },
  unregisterIntegration: function(integrationName) {
    if(integrationName) {
      delete integrationRegistry[integrationName];
      return;
    }

    integrationRegistry = {};
  },
  useIntegration: function(integrationName, options) {
    var callback = integrationRegistry[integrationName];

    if(typeof callback !== 'function') {
      throw new Error('integration "' + integrationName + '" does not exist');
    }

    integrations.add(callback, options);
  },
  identify: function(userId) {
    var args = [].slice.call(arguments);

    /*
    * Segments setup user traits and keep it in storage and cookie than we call `identify` method,
    * we need to clean up this traits from analytics every time no matter have we or not `userId`,
    * because segment use this data in `track` method.
    * Issue: https://github.com/yola/production/issues/11008
    */
    const cleanUpUserTraits =  () => {
      var userIdFromStore = window.analytics.user().id();

      if (userIdFromStore) {
        window.analytics.user().id(null);
        window.analytics.user().traits({});
        console.log("User traits were cleared");
      }
    }

    if (!this.isReady) {
      this.ready(cleanUpUserTraits);
    } else {
      cleanUpUserTraits();
    }

    if (!userId) {
      return Promise.resolve();
    }

    var trackUser = new Promise(function(resolve) {
      var callback = isFunction(args[args.length - 1]) ? args.pop() : function() {};
      var commonCallback = function() {
        callback();
        resolve();
      };
      var intergrationData = integrations.call({});
      args.push({integrations: intergrationData});
      args.push(commonCallback);

      function callIdentify() {
        window.analytics.identify.apply(window.analytics, args);
      }

      if (!this.isReady) {
        this.ready(callIdentify);
      } else {
        callIdentify();
      }
    }.bind(this));

    return trackUser.then(logUser.bind(null, userId));
  },
  page: function(title, path) {
    var pageData = {
      title: title || document.title,
      path: path || window.location.pathname + window.location.hash
    };

    var trackPage = new Promise(function(resolve) {
      function callPage() {
        window.analytics.page(pageData, resolve);
      }

      if (!this.isReady) {
        this.ready(callPage);
      } else {
        callPage();
      }
    }.bind(this));

    return trackPage.then(logInfo.bind(null, pageData));
  },
  track: function(event, props) {
    var trackEvent = new Promise(function(resolve) {
      function callTrack() {
        var intergrationData = integrations.call({});

        window.analytics.track(event, props, {integrations: intergrationData}, resolve);
      }

      if (!this.isReady) {
        this.ready(callTrack);
      } else {
        callTrack();
      }
    }.bind(this));

    return trackEvent.then(logEvent.bind(null, event));
  },
  trackLink: function(link, eventName, props) {
    if (!link) return;

    link.addEventListener('click', function(event) {
      var href = event.target.getAttribute('href');

      window.analytics.track(eventName, props);

      if(!href) return;

      event.preventDefault();
      setTimeout(function() {
        window.location.replace(href);
      }, 1000);
    });
  },
  getInstance: function() {
    return window.analytics;
  }
};

module.exports = segment;
